module.exports = __webpack_public_path__ + "img/Cargo tracking.5d69e9f3.png";